"use client"

import * as React from "react"
import * as HoverCardPrimitive from "@radix-ui/react-hover-card"

import { cn } from "../utils"

type HoverCardProps = HoverCardPrimitive.HoverCardProps & {
  onScrollClose?: boolean
}

const HoverCard = ({ openDelay = 500, closeDelay = 100, onScrollClose = true, ...props }: HoverCardProps) => {
  const [open, setOpen] = React.useState(false)

  React.useEffect(() => {
    if (onScrollClose && open) {
      const handleScroll = () => {
        setOpen(false)
      }

      window.addEventListener("scroll", handleScroll, true)
      return () => {
        window.removeEventListener("scroll", handleScroll, true)
      }
    }
  }, [onScrollClose, open])

  return (
    <HoverCardPrimitive.Root
      openDelay={openDelay}
      closeDelay={closeDelay}
      open={open}
      onOpenChange={setOpen}
      {...props}
    />
  )
}
HoverCard.displayName = "HoverCard"

const HoverCardTrigger = HoverCardPrimitive.Trigger

const HoverCardContent = React.forwardRef<
  React.ElementRef<typeof HoverCardPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof HoverCardPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
  <HoverCardPrimitive.Portal>
    <HoverCardPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      collisionPadding={10}
      className={cn(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-64 rounded-md border p-3 shadow-md outline-hidden",
        className
      )}
      {...props}
    />
  </HoverCardPrimitive.Portal>
))
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName

export { HoverCard, HoverCardTrigger, HoverCardContent }
